import React from "react";
import './caption.css'

export function CaptionStepComponent({className, children, title}) {
    return (<div className={(className ? className : "")}>
        <span className="captionStepTitle">{title}</span>
        <div className="captionParagraphs">
            {children}
        </div>
    </div>)
}

export function FullCaptionComponent({className, children, title}) {
    return (<div className={className + " caption"}>
        <h4 className="captionFullTitle">{title}</h4>
        <div className="captionSteps">
            {children}
        </div>
    </div>)
}
